import React from 'react';
import * as styles from './List.style';

export type ListProps = React.PropsWithChildren<{}>;
export type ListItemProps = React.PropsWithChildren<{}>;

export interface ListComposition {
  Item: typeof ListItem,
}

export const ListItem: React.FC<ListItemProps> = ({
  children,
}) => (
  <li
    css={styles.item}
    data-ref="list-item"
  >
    {children}
  </li>
);

const List: React.FC<ListProps> & ListComposition = ({
  children,
}) => (
  <ul
    css={styles.base}
    data-ref="list"
  >
    {children}
  </ul>
);

List.Item = ListItem;

export default List;
